import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';

import { DirectivesAngularModule } from 'rev-shared/util/directives/DirectivesAngular.Module';
import { FormDirectivesAngularModule } from 'rev-shared/util/directives/form/FormDirectivesAngular.Module';
import { PushModule } from 'rev-shared/push/Push.Module';
import { SecurityAngularModule } from 'rev-shared/security/SecurityAngular.Module';
import { SecurityComponentsModule } from 'rev-shared/security/components/SecurityComponents.Module';
import { SpinnerAngularModule } from 'rev-shared/ui/spinner/SpinnerAngular.Module';
import { VbAuthLayoutModule } from 'rev-shared/ui/authLayout/VbAuthLayout.Module';
import { VbBtnPrimaryDirective } from 'rev-shared/ui/buttons/VbBtnPrimary.Directive';

import { EmbedLoginComponent } from './EmbedLogin.Component';

@NgModule({
	declarations: [
		EmbedLoginComponent
	],
	exports: [
		EmbedLoginComponent
	],
	imports: [
		CommonModule,
		DirectivesAngularModule,
		FormDirectivesAngularModule,
		FormsModule,
		PushModule.forRoot(true),
		SecurityAngularModule,
		SecurityComponentsModule,
		SpinnerAngularModule,
		TranslateModule,
		VbAuthLayoutModule,
		VbBtnPrimaryDirective
	]
})
export class EmbedLoginModule {}
